import { render, staticRenderFns } from "./CustomerTab.vue?vue&type=template&id=3508fe41&scoped=true"
import script from "./CustomerTab.vue?vue&type=script&lang=js"
export * from "./CustomerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3508fe41",
  null
  
)

export default component.exports